import { Box, Typography } from '@mui/material';
import { ToastContentProps } from 'react-toastify';
import { TMaterialStyles } from '../../theme';
import { Illustration } from '../Illustration';
import { Icon } from '../Icon';

export type TAlertData = {
  title: string;
  subtitle?: string;
};

//Not use React.FC becouse toast catch error with types
export const Alert = ({ toastProps, data }: ToastContentProps<TAlertData>) => {
  switch (toastProps.type) {
    case 'error':
      return (
        <Box sx={materialStyles.toastContainer}>
          <Illustration
            sx={materialStyles.hippoErrorIllustration}
            illustrationName="HippoWithError"
          />
          <Box sx={materialStyles.taostContentContainer}>
            <Typography sx={materialStyles.toastTitle}>{data.title}</Typography>
            <Typography sx={materialStyles.toastSubtitle}>
              {data.subtitle}
            </Typography>
          </Box>
        </Box>
      );
    case 'success':
      return (
        <Box sx={materialStyles.toastContainer}>
          <Icon iconName="SuccessIcon" sx={materialStyles.successIcon} />
          <Box sx={materialStyles.taostContentContainer}>
            <Typography sx={materialStyles.toastTitle}>{data.title}</Typography>
            <Typography sx={materialStyles.toastSubtitle}>
              {data.subtitle}
            </Typography>
          </Box>
          <Illustration
            illustrationName="HippoColoredSuccess"
            sx={materialStyles.hippoColoredSuccessIllustration}
          />
        </Box>
      );
    case 'info':
      return (
        <Box sx={materialStyles.toastContainer}>
          <Box sx={materialStyles.taostContentContainer}>
            <Typography sx={materialStyles.toastTitle}>{data.title}</Typography>
            <Typography sx={materialStyles.toastSubtitle}>
              {data.subtitle}
            </Typography>
          </Box>
        </Box>
      );
    default:
      return null;
  }
};

const materialStyles: TMaterialStyles = {
  toastContainer: {
    px: '10px',
    py: '15px',
    display: 'flex',
    flexDirection: 'row',
    position: 'relative',
    width: '100%',
    alignItems: 'center',
  },
  hippoErrorIllustration: {
    width: '55px',
    height: '65px',
  },
  taostContentContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    marginLeft: '6px',
  },
  toastTitle: {
    fontFamily: 'Rubber Duck !important',
    fontSize: '16px',
    lineHeight: '100%',
    color: 'black',
  },
  toastSubtitle: {
    fontFamily: 'Rubber Duck !important',
    fontSize: '12px',
    lineHeight: '100%',
    color: 'black',
    marginTop: '4px',
  },
  successIcon: {
    width: '37px',
    height: '36px',
  },
  hippoColoredSuccessIllustration: {
    right: '18px',
    top: '4px',
    position: 'absolute',
    width: '64px',
    height: '78px',
  },
};
